import './PriceHistoryTable.css';

import React from 'react';

import classname from '@search/classname/src';

import { PriceHistoryPart } from './PriceHistoryPart';
import { PriceHistoryCard } from './PriceHistoryCard';

const cn = classname.bind(null, 'PriceHistoryTable');

export function PriceHistoryTable({
    history
}: {
    history: readonly PriceHistoryPart[];
}) {
    return (<div className={cn()}>
        {history.map(item => <PriceHistoryCard key={item.date2?.iso ?? ''} item={item} />)}
    </div>);
}
